// extracted by mini-css-extract-plugin
export default {"container":"styles_container__560MJ","loginCard":"styles_loginCard__3-ETr","content":"styles_content__XDW5n","form":"styles_form__Za4Hr","footerText":"styles_footerText__gNgzd"};